import React from 'react'
import MicroFrontend from "../MicroFrontend"

const MagnittLoader = ({data, id}) => {
    return <MicroFrontend
        data={data}
        name={`MagnittLoader${id ? `-${id}` : '-0'}`}
    />
}

export default (MagnittLoader);